

export default {
    getFiltradoMovimientosCaja: (state) => (data) => {

    },
    getFiltradoCodigoContable: (state) => (data) => {
    
    }
}